export function useScrollDrag(
  ref,
  options = { direction: 'both' },
  tolerance = 0,
) {
  const { direction } = options;

  // Don't want to let the mouse capture a click event
  // if scrolling occured, since the elements are clickable.
  let didScroll = false;

  // Create accumulator for x and y values for tolerances.
  let xAcc = 0;
  let yAcc = 0;

  // The initial position (scroll progress and mouse location)
  // when the mouse is pressed down on the element.
  let initialPosition = { scrollTop: 0, scrollLeft: 0, mouseX: 0, mouseY: 0 };

  const mouseMoveHandler = (event) => {
    if (ref.current) {
      // Calculate differences to see how far the user has moved.
      const dx = event.clientX - initialPosition.mouseX;
      const dy = event.clientY - initialPosition.mouseY;

      // Accumulate total distance scroll for tolerances.
      xAcc += Math.abs(dx);
      yAcc += Math.abs(dy);

      // Scroll the element according to those differences.
      if (direction !== 'horizontal') {
        ref.current.scrollTop = initialPosition.scrollTop - dy;
      }
      if (direction !== 'vertical') {
        ref.current.scrollLeft = initialPosition.scrollLeft - dx;
      }

      // Track whether scrolling happened.
      if (xAcc > tolerance || yAcc > tolerance) {
        didScroll = true;
      }
    }
  };

  const mouseUpHandler = () => {
    // Return to cursor. Grab after the user is no longer pressing.
    if (ref.current) ref.current.style.cursor = 'grab';

    // Disable click event if scrolling happened.
    if (didScroll) {
      document.addEventListener('click', captureClick, true);
    }
    // Remove the event listeners since it is not necessary
    // to tract the mouse pos anymore.
    document.removeEventListener('mousemove', mouseMoveHandler);
    document.removeEventListener('mouseup', mouseUpHandler);

    // Reset scroll variables for next event.
    xAcc = 0;
    yAcc = 0;
    didScroll = false;
  };

  const onMouseDown = (event) => {
    if (ref.current) {
      // Save the position at the moment the user presses down.
      initialPosition = {
        scrollLeft: ref.current.scrollLeft,
        scrollTop: ref.current.scrollTop,
        mouseX: event.clientX,
        mouseY: event.clientY,
      };

      // Show a cursor. Grabbing style and set user-select to none
      // to avoid selecting text.
      ref.current.style.cursor = 'grabbing';
      ref.current.style.userSelect = 'none';

      // Add the event listeners that will track the mouse pos.
      document.addEventListener('mousemove', mouseMoveHandler);
      document.addEventListener('mouseup', mouseUpHandler);
    }
  };

  const captureClick = (event) => {
    event.stopPropagation();
    document.removeEventListener('click', captureClick, true);
  };

  return { onMouseDown };
}
